import { Button } from "devextreme-react";

interface Props {
  accept: string;
  getUploadUrl(e: any): void;
  fileUploader: any;
  buttonName?: string;
}

const FileUpload = ({ accept, getUploadUrl, fileUploader, buttonName = "파일 추가" }: Props) => {
  return (
    <>
      <label htmlFor={`file`} onChange={e => getUploadUrl(e)}>
        <input ref={fileUploader} hidden type="file" id={`file`} accept={accept} multiple />
        <Button width={100} stylingMode="outlined" text={buttonName} type="default" />
      </label>
    </>
  );
};

export default FileUpload;
